import React, { useState } from "react";
import {
    Button, Divider, Grid, IconButton, InputLabel, List, ListItem, ListItemText, OutlinedInput, Typography
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLicitacoesState } from "../context/licitacoes-context";
import { useLicitacoesController } from "../context/licitacoes-controller";
import { IItemLicitacaoRequest } from "../../../../model/admin-portal/request/item-licitacao-request";
import { TextInputWithCounter } from "../../../components/text-input-with-counter";
import { CurrencyInput } from "../../../components/currency-input";

const emptyDraft: IItemLicitacaoRequest = { id: 0, descricao: '', quantidade: 0, unidadeMedida: '', valorUnitario: 0 };

export const LicitacaoItensSection = () => {
    const { dataRequest } = useLicitacoesState();
    const { saveItem, removeItem } = useLicitacoesController();
    const [draft, setDraft] = useState<IItemLicitacaoRequest>(emptyDraft);
    const [editingIndex, setEditingIndex] = useState<number | undefined>(undefined);

    const handleEdit = (index: number) => {
        setDraft(dataRequest.itens[index]);
        setEditingIndex(index);
    };

    const handleCancel = () => {
        setDraft(emptyDraft);
        setEditingIndex(undefined);
    };

    const handleSave = () => {
        if (!draft.descricao || !draft.unidadeMedida || draft.quantidade <= 0 || draft.valorUnitario <= 0) return;
        saveItem(draft, editingIndex);
        handleCancel();
    };

    return (
        <Grid item lg={12} sm={12} xl={12}>
            <Typography variant="subtitle1" fontWeight="bold">Itens</Typography>
            <Divider sx={{ mb: 1 }} />

            {dataRequest.itens.length > 0 && (
                <List dense>
                    {dataRequest.itens.map((item, index) => (
                        <ListItem
                            key={index}
                            divider
                            secondaryAction={
                                <React.Fragment>
                                    <IconButton size="small" onClick={() => handleEdit(index)}><EditIcon fontSize="small" /></IconButton>
                                    <IconButton size="small" onClick={() => removeItem(index)}><DeleteIcon fontSize="small" /></IconButton>
                                </React.Fragment>
                            }
                        >
                            <ListItemText
                                primary={item.descricao}
                                secondary={`${item.quantidade} ${item.unidadeMedida} x ${item.valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                            />
                        </ListItem>
                    ))}
                </List>
            )}

            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                <Grid item lg={4} sm={6} xl={4}>
                    <InputLabel>Descrição *</InputLabel>
                    <TextInputWithCounter
                        size="small"
                        maxLength={100}
                        error={false}
                        value={draft.descricao}
                        onChange={(e) => setDraft({ ...draft, descricao: e.target.value })}
                        fullWidth
                    />
                </Grid>
                <Grid item lg={2} sm={3} xl={2}>
                    <InputLabel>Quantidade *</InputLabel>
                    <OutlinedInput
                        size="small"
                        type="number"
                        error={false}
                        value={draft.quantidade || ''}
                        onChange={(e) => setDraft({ ...draft, quantidade: Number(e.target.value) })}
                        fullWidth
                    />
                </Grid>
                <Grid item lg={2} sm={3} xl={2}>
                    <InputLabel>Unidade de Medida *</InputLabel>
                    <TextInputWithCounter
                        size="small"
                        maxLength={30}
                        error={false}
                        value={draft.unidadeMedida}
                        onChange={(e) => setDraft({ ...draft, unidadeMedida: e.target.value })}
                        fullWidth
                    />
                </Grid>
                <Grid item lg={2} sm={6} xl={2}>
                    <InputLabel>Valor Unitário *</InputLabel>
                    <CurrencyInput
                        size="small"
                        error={false}
                        value={draft.valorUnitario}
                        onChange={(value) => setDraft({ ...draft, valorUnitario: value })}
                        fullWidth
                    />
                </Grid>
                <Grid item lg={2} sm={12} xl={2} sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={editingIndex === undefined ? <AddIcon /> : undefined}
                        onClick={handleSave}
                        disabled={!draft.descricao || !draft.unidadeMedida || draft.quantidade <= 0 || draft.valorUnitario <= 0}
                    >
                        {editingIndex === undefined ? 'Adicionar' : 'Salvar'}
                    </Button>
                    {editingIndex !== undefined && (
                        <Button size="small" onClick={handleCancel}>Cancelar</Button>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};
